/**
 *  17/01/2019 v 1.0 - JuanMa
 *  v1.1 27/03/2019 En filtrarNombreCampo, añadida bifurcacion si es String, para solo hacer toUpper en ese caso.
 *  v1.2 24/10/2019 Añadida función filtrarConTodosCampos
 *  v1.3 30/10/2019 Añadida función contieneElementoConNomberCampo
 *                  Añadida funcion getPosElementoConNombreCampo
 **/

export const filtrarConIndiceCampo= (datos, indiceCampo, valor) => {
    if (datos.length > 0) {
        let nombreCampo=  Object.keys(datos[0])[indiceCampo];
        return filtrarConNombreCampo(datos, nombreCampo, valor);
    }
}

export const filtrarConNombreCampo= (datos, nombreCampo, filtro) => {
    let newDatos = datos.reduce((newDatosReduced, dato) => {
        let valorActual= dato[nombreCampo];
        //Cuando es cadena pasamos a mayusculas
        if (typeof valorActual === 'string') {
            if (valorActual.toUpperCase().includes(filtro.toUpperCase()))
                newDatosReduced.push(dato);
        }
        else{
            if (valorActual === filtro)
                newDatosReduced.push(dato);
        }
        return newDatosReduced;
    }, []);
    return newDatos;
}

export const contieneElementoConNombreCampo= (datos, nombreCampo, valorBuscado) => {
    let encontrado= false;
    datos.forEach( (dato) => {
        if (!encontrado) {
            let valorActual = dato[nombreCampo];
            //Cuando es cadena pasamos a mayusculas
            if (typeof valorActual === 'string') {
                if (valorActual.toUpperCase() === valorBuscado.toUpperCase())
                    encontrado= true;
            } else {
                if (valorActual === valorBuscado)
                    encontrado= true;
            }
        }
    });
    return encontrado;
}

export const getPosElementoConNombreCampo= (datos, nombreCampo, valorBuscado) => {
    let pos= -1;
    let posActual= 0;
    datos.forEach( (dato) => {
        if (pos < 0) {
            let valorActual = dato[nombreCampo];
            //Cuando es cadena pasamos a mayusculas
            if (typeof valorActual === 'string') {
                if (valorActual.toUpperCase() === valorBuscado.toUpperCase())
                    pos= posActual;
            } else {
                if (valorActual === valorBuscado)
                    pos= posActual;
            }
            posActual++;
        }
    });
    return pos;
}

export const filtrarConTodosCampos= (datos, filtro) => {
    let newDatos = datos.reduce((newDatosReduced, dato) => {
        //Recorremos todas las propiedades
        let encontrado= false;
        for (const prop in dato) {
            if (!encontrado) {
                let valorActual = dato[prop];
                //Cuando es cadena pasamos a mayusculas
                if (typeof valorActual === 'string') {
                    if (valorActual.toUpperCase().includes(filtro.toUpperCase())) {
                        newDatosReduced.push(dato);
                        encontrado = true;
                    }
                } else {
                    if (valorActual === filtro) {
                        newDatosReduced.push(dato);
                        encontrado = true;
                    }
                }
            }
        }
        return newDatosReduced;
    }, []);
    return newDatos;
}

export const filtrarConFiltro= (datos, filtro) => {
    let newDatos = datos.reduce((newDatosReduced, dato) => {
        let datoAceptado= true;
        //Recorremos los campos del filtro y aplicamos los que tengan valor
        for (var i=0; i < Object.keys(filtro).length; i++){
            let filtroNombreCampo= Object.keys(filtro)[i];
            if (datoAceptado) {
                let filtroValorCampo = filtro[filtroNombreCampo];
                if (filtroValorCampo) {
                    let datoValorCampo = dato[filtroNombreCampo];
                    datoAceptado = datoValorCampo.toUpperCase().includes(filtroValorCampo.toUpperCase());
                }
            }
        }
        /*
        Object.keys(filtro).map( (filtroNombreCampo) => {
            if (datoAceptado) {
                let filtroValorCampo = filtro[filtroNombreCampo];
                if (filtroValorCampo) {
                    let datoValorCampo = dato[filtroNombreCampo];
                    datoAceptado = datoValorCampo.toUpperCase().includes(filtroValorCampo.toUpperCase());
                }
            }
            return ""
        });
        */
        if (datoAceptado)
            newDatosReduced.push(dato);
        return newDatosReduced;
    }, []);
    return newDatos;
}

export const eliminarElemento= (datos, nombreCampo, valorCampo) => {
    let newDatos = datos.reduce((newDatosReduced, dato) => {
        if (dato[nombreCampo] !== valorCampo)
            newDatosReduced.push(dato);
        return newDatosReduced;
    }, []);
    return newDatos;

}

export const inArrayInt= (datos, valorBuscado) => {
    for (var i = 0; i < datos.length; i++) {
        if (datos[i] === valorBuscado)
            return true;
    }
    return false;
}